import styled from 'styled-components';

export const MainContainer = styled.div`
  overflow-x: hidden;
  background: ${({ theme }) => theme.colorNeutralBackground3};
`;

export const TabContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: space-evenly;
  align-items: flex-start;
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

export const WidgetsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 1rem;
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
  }
`;
